import React, { useEffect, useState, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { Grid } from "semantic-ui-react";
import { EvalContext } from "./EvalContext";
import { AppContext } from "../../../context/appContext";
import MarksNav from "./marksnav";
import TotalEvalMarks from "./totEvalMarks";
// import TotalEvalMarks from "./totEvalMarks";
import MarksDetails from "./marksDetails";
import {
  Icon,
  Modal,
  Button,
  Sticky,
  Portal,
  Card,
  Segment,
  Header,
  Ref,
} from "semantic-ui-react";
import tdvs from "../../../api2/tdvs";
// import ten from "../../../assets/img/eval_images/10.png";

const images = require.context("../../../assets/img/eval_images/", true);

const RenderImage = (
  item,
  setImgSel,
  dispatch_img,
  qmarks,
  isImgSel,
  marks_img,
  dispatch_marks_img,
  dispatch_marks,
  marks,
  dispatch_msg,
  totmarks,
  setTmarks,
  setRotation,
  rotation,
  zoomLevel,
  setZoomLevel
) => {
  console.log(item, "item");

  // const { onImageError } = props;
  // const handleImageError = onImageError || this.handleImageError;
  const itemSrc = item.original;
  const handleImageLoaded = (event, item) => {};
  const handleOnMouseClick = (e, item) => {
    if (isImgSel) {
      setImgSel(false);
      const key = Math.floor(Math.random() * 90000) + 10000;
      // dispatch_msg
      let curmarks =
        parseFloat(marks.curval.fmarks) == -1
          ? 0
          : parseFloat(marks.curval.fmarks);
      let nmarks = curmarks + parseFloat(qmarks);

      if (nmarks > marks.curval.fmaxmarks) {
        dispatch_msg({
          type: "OPEN_MSG_BOX",
          payload: {
            header: "Message",
            message: "Cannot award more than max. marks",
          },
        });
        return;
      }
      // e.nativeEvent.offsetX
      dispatch_marks_img({
        type: "ADD_MARKS_IMAGE",
        payload: {
          key: key,
          x: 50,
          y: e.nativeEvent.offsetY,
          index: item.index,
          qmarks,
          qkey: marks.curval.fqncode,
        },
      });
      dispatch_marks({
        type: "UPDATE_MARKS",
        payload: {
          key,
          qmarks,
        },
      });
      dispatch_marks({
        type: "UPDATE_MARKS_PARENT",
        payload: {
          key,
          qmarks,
        },
      });
      setTmarks(parseFloat(totmarks) + parseFloat(qmarks));
    }
  };

  const rotateImage = (index) => {
    setRotation((prev) => {
      const newRotation = { ...prev };
      newRotation[index] = (newRotation[index] || 0) + 90; // Increase rotation by 90 degrees
      return newRotation;
    });
  };

  // Function to zoom in on an image
  const zoomIn = (index) => {
    setZoomLevel((prev) => {
      const newZoom = { ...prev };
      newZoom[index] = (newZoom[index] || 1) + 0.1; // Increase zoom level by 10%
      return newZoom;
    });
  };

  const zoomOut = (index) => {
    setZoomLevel((prev) => {
      const newZoom = { ...prev };
      newZoom[index] = (newZoom[index] || 1) - 0.1; // Decrease zoom level by 10%
      return newZoom;
    });
  };

  const marks_img_display = marks_img.filter((el) => el.index === item.index);

  return (
    <div>
      <div>
        <div
          style={{ position: "absolute", top: "0", right: "1", zIndex: 9999 }}
        >
          <button
            onClick={() => rotateImage(item.index)}
            style={{
              background: "rgba(0,0,0,0.5)",
              color: "white",
              padding: "5px",
              border: "none",
              cursor: "pointer",
              fontSize: "12px",
            }}
          >
            Rotate
          </button>
          <button
            onClick={() => zoomIn(item.index)}
            style={{
              background: "rgba(0,0,0,0.5)",
              color: "white",
              padding: "5px",
              border: "none",
              cursor: "pointer",
              fontSize: "12px",
              marginTop: "5px",
            }}
          >
            Zoom In
          </button>
          <button
            onClick={() => zoomOut(item.index)}
            style={{
              background: "rgba(0,0,0,0.5)",
              color: "white",
              padding: "5px",
              border: "none",
              cursor: "pointer",
              fontSize: "12px",
              marginTop: "5px",
            }}
          >
            Zoom Out
          </button>
        </div>
        <img
          className="image-gallery-image"
          src={itemSrc}
          alt={item.originalAlt}
          srcSet={item.srcSet}
          sizes={item.sizes}
          title={item.originalTitle}
          onLoad={(event) => handleImageLoaded(event, item)}
          onClick={(e) => handleOnMouseClick(e, item)}
          // onError={handleImageError}
          style={{
            transform: `rotate(${rotation[item.index] || 0}deg) scale(${
              zoomLevel[item.index] || 1
            })`, // Apply both rotation and zoom dynamically
            transition: "transform 0.3s ease", // Smooth transition for both zoom and rotation
          }}
        />
        {marks_img_display.map((el) => {
          let h = "50px";
          let w = "50px";
          if (el.qmarks === "y") {
            return;
          }
          if (el.qmarks === "x") {
            h = "120vh";
            w = "80%";
          }
          return (
            <span
              key={el.key}
              style={{
                position: "absolute",
                display: "flex",
                zIndex: "999",
                top: `${el.y}px`,
                left: `${el.x}px`,
              }}
            >
              <img
                key={el.key}
                src={images(`./${el.qmarks}.png`)}
                alt={el.qmarks}
                style={{ height: h, width: w }}
              />
            </span>
          );
        })}
      </div>
      {item.description && (
        <span className="image-gallery-description">{item.description}</span>
      )}
    </div>
  );
};

const RenderThumbInner = ({ item, marks_img }) => {
  // const { onThumbnailError } = this.props;
  // const handleThumbnailError = onThumbnailError || this.handleImageError;
  // check circle outline
  const check = marks_img.filter((el) => el.index === item.index)[0];
  const [loading, setloading] = useState(false);
  return (
    <div
      className="image-gallery-thumbnail-inner"
      style={{ display: loading ? "block" : "none" }}
    >
      {check === undefined ? (
        <Icon
          name="times circle outline"
          color="red"
          size="big"
          style={{ position: "absolute", top: "10%", left: "70%" }}
        />
      ) : (
        <Icon
          name="check circle outline"
          color="green"
          size="big"
          style={{ position: "absolute", top: "10%", left: "70%" }}
        />
      )}

      <img
        className="image-gallery-thumbnail-image"
        src={item.thumbnail}
        alt={item.thumbnailAlt}
        title={item.thumbnailTitle}
        onLoad={() => setloading(true)}
        // onError={handleThumbnailError}
      />
      {item.thumbnailLabel && (
        <div className="image-gallery-thumbnail-label">
          {/* {item.thumbnailLabel} */}
        </div>
      )}
    </div>
  );
};

const ImageViewer = (props) => {
  // const [images, setImages] = useState([]);
  const history = useHistory();
  const { teachcode, err_msg, load } = useContext(AppContext);
  const [error, dispatch_err] = err_msg;
  const [loader, setLoader] = load;
  // const [fteachcode, setFteachcode] = teachcode;
  const fteachcode = sessionStorage.getItem("fteachcode");
  const gallRef = useRef(null);
  const {
    tmarks,
    pointer,
    gallery,
    imgSelState,
    qmarks,
    marks_img_state,
    curval,
    markslist,
    message,
    subject,
  } = useContext(EvalContext);

  const [sindex, setSindex] = useState(0);
  const [totmarks, setTmarks] = tmarks;
  const [fomrmarks, setOmrMarks] = useState("");
  const [pointerClass, setPointerClass] = pointer;
  const [images, dispatch_img] = gallery;

  const [isImgSel, setImgSel] = imgSelState;
  const [que_marks] = qmarks;

  const [marks_img, dispatch_marks_img] = marks_img_state;
  const [curValQn, setcurValQn] = curval;

  const [marks, dispatch_marks] = markslist;
  const [msg, dispatch_msg] = message;

  const [subInfo, setsubInfo] = subject;

  // marks_img: [marks_img, dispatch_marks_img]
  const handle = useFullScreenHandle();
  // useEffect(() => {
  //   async function a() {
  //     try {
  //       await handle.enter();
  //     } catch (e) {
  //     }
  //   }
  //   a();
  // }, []);

  useEffect(() => {
    let fregcode = props.match.params.ifregcode;
    let fqpcode = props.match.params.ifqpcode;
    let fvalno = props.match.params.ifvalno;
    // let [fqpcode, fpacket, fslno] = fregcode.split("-");
    setsubInfo({ fqpcode, fregcode });

    const getApiData = async () => {
      try {
        setLoader(true);
        const img_resp = await tdvs.get(
          "/app.php?a=getevalimageStud&univcode=030" +
            `&qpcode=${fqpcode}&regcode=${fregcode}&valno=${fvalno}`
        );

        // const img_resp = await digiNodeApi.get(
        //   `/eval/get-val-images-vips?fqpcode=${fqpcode}&fregcode=${fregcode}&fvalno=${fvalno}&fteachcode=${fteachcode}`
        // );

        let res1 = img_resp.data;

        if (res1.error_code == 0) {
          dispatch_img({ type: "SET_IMAGES", payload: res1.data });
        } else {
          history.push("/dashboard");
          throw new Error(res1.msg);
        }

        // const eval_state = await digiNodeApi.get(
        //   `/eval/get-eval-sate?fqpcode=${fqpcode}&fregcode=${fregcode}&fvalno=${fvalno}`
        // );

        const eval_state = await tdvs.get(
          "/app.php?a=onscreenMarksingVal&univcode=030" +
            `&qpcode=${fqpcode}&regcode=${fregcode}&valno=${fvalno}`
        );

        const res = eval_state.data.data;
        console.log(eval_state, "eval_state.data.data");

        if (eval_state.data.error_code == 0) {
          let fimgpos = JSON.parse(res.qdata.fimgposjson);

          let fmarks = JSON.parse(res.qdata.fmarksjson);
          console.log(fmarks, "Sasjkhaskajhk");

          if (fmarks.parts.length == 0) {
            const eval_qp_detl = await tdvs.get(
              "/app.php?a=getQpEvalDet&univcode=030" +
                `&qpcode=${fqpcode}&regcode=${fregcode}`
            );

            setOmrMarks(eval_qp_detl.data.data.path[0].fomrmarks);
            const res2 = eval_qp_detl.data;

            if (res2.error_code == 0) {
              dispatch_marks({
                type: "INIT_MARKS_TEMPLATE",
                payload: res2.data,
              });
            } else {
              throw new Error(res2.data.data.msg);
            }
          } else {
            let fimgpos_last = fimgpos[fimgpos.length - 1];
            if (fvalno !== "W") setSindex(2);

            setTmarks(parseFloat(res.qdata.fmarks));
            setOmrMarks(res.qdata.fomrmarks);
            // dispatch_marks({
            //   type: "UPDATE_DRAFT_MARKS",
            //   payload: fmarks,
            // });
            dispatch_marks_img({
              type: "UPDATE_DRAFT_IMAGE",
              payload: fimgpos,
            });
          }
        }
        setLoader(false);
      } catch (err) {
        setLoader(false);
        if (err.response && err.response.status == 401) {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Message",
              message: "Authentication failed. Login again !!!",
            },
          });
          history.push(sessionStorage.getItem("rootPath"));
        } else {
          dispatch_err({
            type: "OPEN_MSG_BOX",
            payload: {
              header: "Message",
              message: err.message,
            },
          });
        }
      }
    };
    getApiData();
  }, [0]);

  const [open, setOpen] = useState(false);
  const [rotation, setRotation] = useState({});
  const [zoomLevel, setZoomLevel] = useState({});
  const stick_ref = useRef();

  return (
    <div>
      <FullScreen handle={handle}>
        <Ref innerRef={stick_ref}>
          {/* <Grid style={{ backgroundColor: "#fff" }}> */}
          {/* <Grid.Column width={1} style={{ paddingRight: "0px" }}>
              <Modal
                size={"mini"}
                open={msg.open}
                onClose={() => setOpen(false)}
              >
                <Modal.Header
                  style={{ backgroundColor: msg.color, color: "#fff" }}
                >
                  {msg.header}
                </Modal.Header>
                <Modal.Content>
                  <p>{msg.message}</p>
                </Modal.Content>
                <Modal.Actions>
                  <Button
                    positive
                    onClick={() => dispatch_msg({ type: "CLOSE_MSG_BOX" })}
                  >
                    OK
                  </Button>
                </Modal.Actions>
              </Modal>

              <MarksNav galref={gallRef} />
            </Grid.Column> */}
          {/* <Grid.Column width={10} style={{ paddingLeft: "0px" }}> */}
          <div style={{ display: "flex" }}>
            <div
              className={isImgSel ? pointerClass : ""}
              style={{
                width: "60%",
                height: "100vh",
                overflowY: "auto",
                scrollbarWidth: "none",
              }}
            >
              <ImageGallery
                ref={gallRef}
                items={images}
                thumbnailPosition="right"
                showFullscreenButton={false}
                showPlayButton={false}
                disableThumbnailScroll={true}
                infinite={false}
                startIndex={sindex}
                lazyLoad={true}
                showIndex={true}
                renderItem={(item) =>
                  RenderImage(
                    item,
                    setImgSel,
                    dispatch_img,
                    que_marks,
                    isImgSel,
                    marks_img,
                    dispatch_marks_img,
                    dispatch_marks,
                    marks,
                    dispatch_msg,
                    totmarks,
                    setTmarks,
                    setRotation,
                    rotation,
                    zoomLevel,
                    setZoomLevel
                  )
                }
                // RenderThumbInner
                // renderThumbInner={(item) => renderThumbInner(item, marks_img)}
                renderThumbInner={(item) => (
                  <RenderThumbInner item={item} marks_img={marks_img} />
                )}
              />
            </div>
            <div
              style={{
                width: "40%",
                height: "100vh",
                overflowY: "auto",
                scrollbarWidth: "none",
                margin: 5,
              }}
            >
              <TotalEvalMarks {...props} fullscreen={handle.enter} />
            </div>
          </div>
          {/* </Grid.Column> */}
          {/* <Grid.Column width={6}>
              <Sticky context={stick_ref}>
                <div style={{ marginRight: "1em", marginTop: "1em" }}>
                  <TotalEvalMarks {...props} fullscreen={handle.enter} />
                </div>
              </Sticky>
            </Grid.Column> */}
          {/* </Grid> */}
        </Ref>
      </FullScreen>
    </div>
  );
};

export default ImageViewer;
